import script from "./NewsDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsDetailView.vue?vue&type=script&setup=true&lang=js"

import "./NewsDetailView.vue?vue&type=style&index=0&id=61ff1e4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ff1e4e"]])

export default __exports__